export default __webpack_public_path__ + "static/twitter-image-1eda9ea640227dbf20f7e3aad6ef4933.png";